// define custom colos for xFinity theme
const deepGrey = Object.freeze({
    base: '#868F96',
    lighten9: '#FBFCFC',
    lighten8: '#F2F4F5',
    lighten7: '#EEF1F3',
    lighten6: '#EBEEF0',
    lighten5: '#E6EAED',
    lighten4: '#DDE2E6',
    lighten3: '#C7CDD2',
    lighten2: '#B1B9BF',
    lighten1: '#9BA4AA',
    darken1: '#646A70',
    darken2: '#44484C',
    darken3: '#2A2C2D',
    darken4: '#191919'
});

const oceanBlue = Object.freeze({
    base: '#00619A'
});
const skyBlue = Object.freeze({
    base: '#0272B6'
});
const deepBlue = Object.freeze({
    base: '#0B7DBB'
});
const genesBlue = Object.freeze({
    base: '#2B9CD8'
});
const watermelon = Object.freeze({
    base: '#FB543F'
});
const haute = Object.freeze({
    base: '#FF5A5A',
    darken1: '#D9003A'
});
const tangerine = Object.freeze({
    base: '#FF9271',
    darken1: '#BF2C00'
});
const pumpkin = Object.freeze({
    base: '#FFA700'
});
const lemon = Object.freeze({
    base: '#FFD871',
    darken1: '#895A00'
});
const berry = Object.freeze({
    base: '#FF638D',
    darken1: '#B10030'
});
const turq = Object.freeze({
    base: '#4AB1C1'
});
const lagoon = Object.freeze({
    base: '#1BCFE1',
    darken1: '#0C5E66'
});
const greenTea = Object.freeze({
    base: '#1EE2C9',
    darken1: '#0E695D'
});
const minty = Object.freeze({
    base: '#65D0A7',
    darken1: '#24744A'
});
const seaFoam = Object.freeze({
    base: '#47C684'
});
const bramble = Object.freeze({
    base: '#BC43D3',
    darken1: '#8E26A2'
});

export default {
    deepGrey,
    oceanBlue,
    skyBlue,
    deepBlue,
    genesBlue,
    watermelon,
    haute,
    tangerine,
    pumpkin,
    lemon,
    berry,
    turq,
    lagoon,
    greenTea,
    minty,
    seaFoam,
    bramble
};
